import './how_it_works.less';
import React, {PropTypes} from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import classNames from 'classnames';

export default class HowItWorks extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
    <div id="howItWorksWrap">
  		<div id="howItWorksTitleWrap">
        <div className = {classNames('static-header-wrap', {'no-margin-top' : isSessionValid})}>
          <div id="howItWorksTitle">How AWB Works</div>
        </div>
        <div id="howItWorksDescription">AirWayBill is an application that allows you to meet carriers, shippers and international shoppers around the world. Connect, message, ship and pay all in one platform.
  			</div>
  		</div>
  		<div id="howItWorksContentWrap">
  			<div id="shipperSection">
  				<div className="section-title">Ship a Package</div>
  				<div className="section-image-wrap">
  					<div className="section-image-group">
  						<div className="section-image" id="ShipperSectionShipper"></div>
  						<div className="section-image-content-wrap">
  							<div className="section-image-user-type">SHIPPER</div>
  							<div className="section-image-user-name">Lila</div>
  						</div>
  					</div>
  					<div className="section-image-group">
  						<div className="section-image" id="ShipperSectionCarrier"></div>
  						<div className="section-image-content-wrap">
  							<div className="section-image-user-type">CARRIER</div>
  							<div className="section-image-user-name">Manisha</div>
  						</div>
  					</div>
  					<div className="section-image-group">
  						<div className="section-image" id="ShipperSectionReciever"></div>
  						<div className="section-image-content-wrap">
  							<div className="section-image-user-type">RECIPIENT</div>
  							<div className="section-image-user-name">Lila’s Mom</div>
  						</div>
  					</div>
  				</div>
  				<div className="section-content-wrap">
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">1</div>
  						<div className="section-content">Lila lives in the US and wants to ship vitamins worth $15 to India for her mom. She prepares the item (unsealed), takes a photo and posts on AirWayBill. Fee is minimum $20, or 10% of the item value. Since Lila’s mom can meet the carrier at the airport and bottles are fairly small, Lila decides to offer just $30.
  						</div>
  					</div>
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">2</div>
  						<div className="section-content">Manisha is an Indian student studying in the University near Lila’s house. Manisha has a plan to visit home in Delhi for spring break. She checks for packages to carry nearby on AirWayBill, accepts Lila’s offer and provides her travel detail and credit card information to insure the package. She is also aware of the fact that she doesn’t have to declare such low value item.
  						</div>
  					</div>
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">3</div>
  						<div className="section-content">Lila sees that Manisha accepted her offer and sends a message to arrange pick up. Lila and Manisha meet at her school the next day for package hand off.
  						</div>
  					</div>
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">4</div>
  						<div className="section-content">Manisha packs the bottles and gets on board.
  						</div>
  					</div>
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">5</div>
  						<div className="section-content">13 hours later, Manisha messages Lila’s mom through AirWayBill platform to meet at the arrival terminal and delivers the item. Manisha receives delivery fee of $24 to her Paypal account, which is total fee minus AirWayBill fee of $4 (20%).
  						</div>
  					</div>
  				</div>
  			</div>
  			<div id="receiverSection">
  				<div className="section-title">Request an Item / Shop</div>
  				<div className="section-image-wrap">
  					<div className="section-image-group">
  						<div className="section-image" id="receiverSectionShipper"></div>
  						<div className="section-image-content-wrap">
  							<div className="section-image-user-type">REQUESTER</div>
  							<div className="section-image-user-name">Dina</div>
  						</div>
  					</div>
  					<div className="section-image-group">
  						<div className="section-image" id="receiverSectionCarrier"></div>
  						<div className="section-image-content-wrap">
  							<div className="section-image-user-type">CARRIER</div>
  							<div className="section-image-user-name">Karim</div>
  						</div>
  					</div>
  					<div className="section-image-group">
  						<div className="section-image" id="receiverSectionReciever"></div>
  						<div className="section-image-content-wrap">
  							<div className="section-image-user-type">RECIPIENT</div>
  							<div className="section-image-user-name">Dina’s Husband</div>
  						</div>
  					</div>
  				</div>
  				<div className="section-content-wrap">
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">1</div>
  						<div className="section-content">Dina is a young trend setter living in Jeddah. She learns about a perfume brand only available in New York and San Francisco, and wants to try their Ylang fragrance.
  						</div>
  					</div>
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">2</div>
  						<div className="section-content">The website says that the retail price is $300, including tax. Dina requests the item on AirWayBill, and provides her credit card information and store location for purchase. Considering carrier’s effort to make a trip to the store, Dina puts $100 as a carriage fee.
  						</div>
  					</div>
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">3</div>
  						<div className="section-content">Karim, pharmaceutical representative living in Riyadh, travels between Jeddah, New York and Riyadh all the time. He sees Dina’s request and realizes that the perfume store is a block away from his hotel in SoHo. He accepts the offer and arranges delivery with Dina. As they confirm the transaction Dina’s credit card gets charged for the item price and the delivery ($400). Her husband will meet Karim at Red Sea Mall back in Jeddah.
  						</div>
  					</div>
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">4</div>
  						<div className="section-content">Karim makes a quick trip to the store to buy the item. He takes a picture of the receipt and sends to Dina to confirm the price, packs it up brings it back to Jeddah with him.
  						</div>
  					</div>
  					<div className="content-group-wrap">
  						<div className="section-content-bullet">5</div>
  						<div className="section-content">Karim meets Dina’s husband and makes the delivery. He earns $80 for the shopping service he provided, and receives $300 he paid for the perfume as well. He just made enough to fly from Jeddah and Riyadh to see his family!
  						</div>
  					</div>
  				</div>
  			</div>
  		</div>
  	</div>);
  }
}



// WEBPACK FOOTER //
// app/static_pages/how_it_works.jsx